import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { SearchIcon } from "@/components/icons/search-icon";
import IconButton from "@/components/ui/buttons/IconButton";
import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { useIonViewWillEnter } from "@ionic/react";
import { memo, useCallback, useState } from "react";
import { SwapPlanSearchModal } from "../swap-plan-search-modal";

interface SwapPlanSearchProps {
  pageRef: React.RefObject<HTMLElement>;
  mealData: Meal | null;
  mealTime: MealTime | undefined;
  mealDay: string | undefined;
  mealIndex: number | undefined;
  targetDate?: string;
  isExtraMeal?: boolean;
}

export const SwapPlanSearch = memo(function SwapPlanSearch({
  pageRef,
  mealData,
  mealTime,
  mealDay,
  mealIndex,
  targetDate,
  isExtraMeal,
}: SwapPlanSearchProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // True when the modal is being reopened after returning from meal detail —
  // signals to the modal to keep its existing search state instead of resetting.
  const [shouldRestore, setShouldRestore] = useState(false);

  const handleOpenSearch = () => {
    setShouldRestore(false);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setShouldRestore(false);
  };

  const handleOpenMealDetail = useCallback(() => {
    localStorage.setItem(LocalStorageKeys.SWAP_PLAN_REOPEN_SEARCH_MODAL, "true");
    setIsModalOpen(false);
  }, []);

  useIonViewWillEnter(() => {
    const shouldReopen =
      localStorage.getItem(LocalStorageKeys.SWAP_PLAN_REOPEN_SEARCH_MODAL) === "true";
    if (shouldReopen) {
      localStorage.removeItem(LocalStorageKeys.SWAP_PLAN_REOPEN_SEARCH_MODAL);
      setShouldRestore(true);
      setIsModalOpen(true);
    }
  });

  return (
    <>
      <IconButton
        onClick={handleOpenSearch}
        type="button"
        aria-label="Open search"
        className="h-11 w-11 rounded-full"
      >
        <SearchIcon className="h-6 w-6" />
      </IconButton>

      <SwapPlanSearchModal
        pageRef={pageRef}
        isOpen={isModalOpen}
        shouldRestore={shouldRestore}
        onDismiss={handleCloseModal}
        onOpenMealDetail={handleOpenMealDetail}
        mealData={mealData}
        mealTime={mealTime}
        mealDay={mealDay}
        mealIndex={mealIndex}
        targetDate={targetDate}
        isExtraMeal={isExtraMeal}
      />
    </>
  );
});
